var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-setting"},[_c('p',[_vm._v(" 开启后，直播时将主播端语音内容实时转为文字并进行总结，供观众查看。直播中不支持开启，请在直播前开启！ ")]),_c('div',{staticClass:"ai-setting__ft"},[_c('vh-button',{staticClass:"ai-setting-btn",attrs:{"type":"primary","size":"medium","round":""},on:{"click":_vm.goPage}},[_vm._v(" 马上开启 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }